import * as React from "react";

const SvgFog = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="Fog_svg__f">
        <path
          d="M-1073.667 703.639H754.989V-239.75h-1828.656Z"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Fog_svg__e">
        <path
          d="M-1084.486 701.463H744.17v-943.388h-1828.656Z"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Fog_svg__d">
        <path
          d="M-1072.923 690.424H755.733v-943.388h-1828.656Z"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Fog_svg__c">
        <path
          d="M-1091.598 694.116H737.058v-943.388h-1828.656Z"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Fog_svg__b">
        <path
          d="M-1053.118 707.442H775.538v-943.388h-1828.656Z"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Fog_svg__a">
        <path
          d="M-1059.747 699.866H768.909v-943.388h-1828.656Z"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
    </defs>
    <g
      transform="matrix(1.33333 0 0 -1.33333 37.765 47.735)"
      clipPath="url(#Fog_svg__a)"
      style={{
        fill: "#d0e8f8",
        fillOpacity: 1,
      }}
    >
      <path
        d="M0 0c0-7.487-6.07-13.557-13.558-13.557-7.487 0-13.557 6.07-13.557 13.557 0 7.488 6.07 13.558 13.557 13.558C-6.07 13.558 0 7.488 0 0"
        style={{
          fill: "#d0e8f8",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
    </g>
    <g
      transform="matrix(1.33333 0 0 -1.33333 28.926 57.835)"
      clipPath="url(#Fog_svg__b)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <path
        d="M0 0c0 6.852 5.555 12.406 12.407 12.406S24.813 6.852 24.813 0c0-6.853-5.554-12.407-12.406-12.407S0-6.853 0 0"
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
    </g>
    <g
      transform="matrix(1.33333 0 0 -1.33333 80.232 40.068)"
      clipPath="url(#Fog_svg__c)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <path
        d="M0 0c0-5.808-4.708-10.517-10.517-10.517-5.807 0-10.516 4.709-10.516 10.517s4.709 10.517 10.516 10.517C-4.708 10.517 0 5.808 0 0"
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
    </g>
    <g
      transform="matrix(1.33333 0 0 -1.33333 55.333 35.145)"
      clipPath="url(#Fog_svg__d)"
      style={{
        fill: "#d0e8f8",
        fillOpacity: 1,
      }}
    >
      <path
        d="M0 0c0-5.601-4.541-10.142-10.142-10.142-5.601 0-10.141 4.541-10.141 10.142 0 5.602 4.54 10.142 10.141 10.142S0 5.602 0 0"
        style={{
          fill: "#d0e8f8",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
    </g>
    <g
      transform="matrix(1.33333 0 0 -1.33333 70.75 49.864)"
      clipPath="url(#Fog_svg__e)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <path
        d="M0 0a8.864 8.864 0 0 1 8.865-8.864A8.863 8.863 0 0 1 17.729 0 8.865 8.865 0 0 1 0 0"
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
    </g>
    <g
      transform="matrix(1.33333 0 0 -1.33333 56.325 52.765)"
      clipPath="url(#Fog_svg__f)"
      style={{
        fill: "#d0e8f8",
        fillOpacity: 1,
      }}
    >
      <path
        d="M0 0a8.865 8.865 0 1 0 17.73 0A8.865 8.865 0 0 0 0 0"
        style={{
          fill: "#d0e8f8",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
      />
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 503.194 -454.15)"
      d="M-377.396 340.612h72v72h-72z"
    />
  </svg>
);

export default SvgFog;
